import { EventDispatcher } from 'three'

type SizesEvents = {
	resize: {}
	'mq-change': {}
}

export class Sizes extends EventDispatcher<SizesEvents> {
	public readonly pixelRatio: number
	public width: number
	public height: number
	public isDesktop: boolean

	constructor(container: HTMLElement) {
		super()
		const { width, height } = container.getBoundingClientRect()
		this.width = Math.round(width)
		this.height = Math.round(height)
		this.pixelRatio = Math.min(window.devicePixelRatio, 1.5)
		const mq = window.matchMedia('(min-width:768px)')
		this.isDesktop = mq.matches

		mq.addEventListener('change', () => {
			this.isDesktop = mq.matches
			this.dispatchEvent({ type: 'mq-change' })
		})

		const observer = new ResizeObserver(() => {
			const { width, height } = container.getBoundingClientRect()
			this.width = Math.round(width)
			this.height = Math.round(height)
			this.dispatchEvent({ type: 'resize' })
		})

		observer.observe(container)
	}
}
